<template>
  <van-loading type="spinner" />
</template>

<script>
import { apiGetOpenId, ApiGetMiniInfo } from '@/api/insurance';
import { Loading } from 'vant';
import { userInfoAuth,LinkPage } from './hooks';

const isWechat = () => {
  return (
    String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
    'micromessenger'
  );
};
function objToStr(params) {
  let arr = [];
  for (const key in params) {
    arr.push(`${key}=${params[key]}`);
  }
  let str = arr.join('&');
  return str;
}
export default {
  components: {
    VanLoading: Loading,
  },
  data() {
    return {
      WXcode: '',
    };
  },
  methods: {
    async getWXCode() {
      let { pageType, shareId, shareRoleType, sharePlazaId, wdSign } = this.$route.query;
      let weChatOfficialAccountType = this.$route.query.weChatOfficialAccountType == 2 ? '2' : '1'
      localStorage.setItem('weChatOfficialAccountType', weChatOfficialAccountType)
      let appid = weChatOfficialAccountType == '2' ? 'wxf91f646263070b5f' : 'wx6291bd6ded26851f'
      let mini_token = this.$route.query.mini_token || ''
      localStorage.setItem('mini_token', mini_token || '');
      if (isWechat() && mini_token) {
        // 小程序端
        ApiGetMiniInfo({ token: mini_token }).then(res => {
          // `${location.origin}${location.pathname}#/auth/insure_n_index`
          let base = encodeURIComponent(
            JSON.stringify({
              token: res.token,
              userId: res.userId,
              plazaId: res.plazaId,
              plazaName: res.plazaName,
              storeId: res.storeId,
            })
          );
          if (pageType == 'myBill') {
            window.location.replace(LinkPage('/insureList', {personnelId:res.userId}))
          } else {
            window.location.replace(`${location.origin}${location.pathname}#/wxAuth/insure_n_index?base=${base}`)
          }
        })
      } else if (isWechat()) {
        // 微信端
        // wx84a082d6e1aaaa1a
        let WXcode = this.getUrlCode().code; //是否存在code
        let local = window.location.href;
        // let local = 'https://mp.sit.beyonds.com';
        // let { pageType, shareId, shareRoleType, sharePlazaId, wdSign } = this.$route.query;
        localStorage.setItem('shareId', shareId || '');
        localStorage.setItem('shareRoleType', shareRoleType || '');
        localStorage.setItem('sharePlazaId', sharePlazaId || '');
        localStorage.setItem('wdSign', wdSign || '');
        this.$store.commit('base/setPageType', pageType || '');


        if (WXcode && this.$route.path.includes('_dev')) {
          // http://wicmp.wanda-dev.cn/?code=061gLH000u4FSQ1isM000nhMMN2gLH0F&state=STATE#/insure_auth?pageType=insure_operating&weChatOfficialAccountType=1

          let queryArr = []
          for (const key in this.$route.query) {
            queryArr.push(`${key}=${this.$route.query[key]}`)
          }
          let queryStr = queryArr.join('&')
          window.location.replace(`http://wicmp-sit.wandawic.com/h5-app-sh/?code=${WXcode}&state=STATE#/insure_auth?${queryStr}`)
          return
        }

        if (WXcode == null || WXcode === '') {
          //不存在就打开上面的地址进行授权
          // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
          //   local
          // )}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
          window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`)
        } else {
          this.WXcode = WXcode;
          let openId = await apiGetOpenId(this.WXcode);
          if (openId) {
            localStorage.setItem('insure_openId', openId);
          }
          openId = localStorage.getItem('insure_openId');
          userInfoAuth();
        }
      } else {
        this.$toast({
          type: 'fail',
          message: '请在微信内打开',
          overlay: true,
          forbidClick: true,
          duration: 0
        })
      }
    },
    getUrlCode() {
      // 截取url中的code方法
      let url = location.search;
      let theRequest = new Object();
      if (url.indexOf('?') != -1) {
        var str = url.substr(1);
        var strs = str.split('&');
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
        }
      }
      console.log(theRequest);
      return theRequest;
    },
  },
  mounted() {
    localStorage.clear()
    setTimeout(()=>{
      this.getWXCode();
    },500)

  },
};
</script>
